import { useState, useEffect } from "react";
import { json } from "d3";

const newUrl =
  "https://gist.githubusercontent.com/Nfuu/24fb6878d427f34a389bcbaf1ca3cfd4/raw/bc890a60d567aa7920e4b033c49d5c1d40860f6c/worldmap.geojson";

const useMapData = () => {
  const [data, setData] = useState(null);
  const [rawGeoJson, setRawGeoJson] = useState(null);

  useEffect(() => {
    json(newUrl).then((topology) => {
      const { features } = topology;
      const filteredFeatures = features.filter((feature) => {
        return feature.id !== "ATA";
      });
      setData(filteredFeatures);

      const newTopology = {
        type: "FeatureCollection",
        features: filteredFeatures,
      };
      setRawGeoJson(newTopology);
    });
  }, []);

  return [data, rawGeoJson];
};

export default useMapData;
